export const useInventoryStatus = (inventoryStatus?: string) => {
  const { t } = useI18n()

  switch (inventoryStatus?.toLowerCase()) {
    case 'lowinventory':
      return t('product.label.inventoryLow')
    case 'notorderable':
    case 'discontinued':
      return t('product.label.inventoryUnorderable')
    case 'backordered':
      return t('product.label.inventoryBackordered')
    case 'retiring':
    case 'retiringlowinventory':
      return t('product.label.inventoryRetiring')
    default:
      return ''
  }
}
